// removed by extract-text-webpack-plugin
module.exports = {"xAxisTicks":"_31wC","xAxisNumbers":"_3xnz","xAxisItemContainer":"_1bht"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LandingPage/Chart/XAxis/styles.scss
// module id = 442
// module chunks = 0